<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

<div [formGroup]="form1">

  <!-- ── MODAL HEADER ── -->
  <div class="kbm-modal-header">
    <div>
      <div class="header-eyebrow">Activities Manager</div>
      <h2 class="header-title">{{formTitle}}</h2>
    </div>
    <button class="close-btn" mat-dialog-close>✕</button>
  </div>

  <!-- ── TAB BAR ── -->
  <div class="kbm-modal-tabs">
    <button *ngFor="let t of TABS" class="modal-tab" [class.active]="activeTab === t" (click)="activeTab = t">
      {{t | titlecase}}
    </button>
  </div>

  <!-- ── BODY ── -->
  <div class="kbm-modal-body">

    <!-- ══════════════════════════════════════════
         TAB: DETAILS
    ══════════════════════════════════════════ -->
    <ng-container *ngIf="activeTab === 'details'">

      <!-- ── AI Auto-fill from URL ── -->
      <div class="kbm-section-label"><span>AI Auto-fill from Provider Website</span></div>
      <div style="background:#f0f9ff;border:1px solid #bae6fd;border-radius:8px;padding:14px 16px;margin-bottom:20px">
        <p style="font-size:12px;color:#0369a1;margin:0 0 10px">
          Paste the provider's website URL and let AI extract the activity name, description, highlights, category, duration, included items, and age restrictions.
          <span *ngIf="!activityId" style="color:#dc2626;font-weight:600"> Save the activity first to enable auto-fill.</span>
        </p>
        <div style="display:flex;gap:8px;align-items:center">
          <input
            class="kbm-input"
            [(ngModel)]="aiPopulateUrl"
            [ngModelOptions]="{standalone:true}"
            placeholder="https://www.provider.com/tour-name"
            style="flex:1"
            [disabled]="aiPopulateLoading"
          />
          <button
            type="button"
            class="btn-kbm-primary"
            (click)="runAiPopulate()"
            [disabled]="aiPopulateLoading || !activityId"
            style="white-space:nowrap;padding:8px 16px;display:flex;align-items:center;gap:6px"
          >
            <i *ngIf="aiPopulateLoading" class="pi pi-spin pi-spinner" style="font-size:14px"></i>
            <span>{{aiPopulateLoading ? 'Analyzing…' : 'Auto-fill with AI'}}</span>
          </button>
        </div>
      </div>

      <div class="kbm-section-label"><span>Basic Information</span></div>
      <div class="kbm-field-grid cols-2" style="margin-bottom:16px">

        <div class="kbm-field span-2">
          <label class="kbm-label">Activity Name <span class="req">*</span></label>
          <input class="kbm-input" formControlName="name" placeholder="e.g. Sunset Snorkel Tour"/>
          <div *ngIf="errMsg('name')" class="kbm-hint" style="color:#ef4444">{{errMsg('name')}}</div>
        </div>

        <div class="kbm-field">
          <label class="kbm-label">Category <span class="req">*</span></label>
          <select class="kbm-select" formControlName="category">
            <option value="">Select…</option>
            <option *ngFor="let c of CATEGORIES" [value]="c.value">{{c.name}}</option>
          </select>
        </div>

        <div class="kbm-field">
          <label class="kbm-label">Activity Type</label>
          <select class="kbm-select" formControlName="activityType">
            <option value="">Select…</option>
            <option *ngFor="let t of ACTIVITY_TYPES" [value]="t.value">{{t.name}}</option>
          </select>
        </div>

        <div class="kbm-field span-2">
          <label class="kbm-label">Short Description <span style="font-size:11px;color:#6b7280">(110-150 chars, shown in listings)</span></label>
          <textarea class="kbm-textarea" formControlName="shortDesc" rows="2" placeholder="Concise luxury description for activity listings…" maxlength="200"></textarea>
        </div>

        <div class="kbm-field span-2">
          <label class="kbm-label">Full Description</label>
          <textarea class="kbm-textarea" formControlName="fullDesc" rows="4" placeholder="Detailed description for guests…"></textarea>
        </div>
      </div>

      <div class="kbm-section-label"><span>Pricing &amp; Capacity</span></div>
      <div class="kbm-field-grid cols-3" style="margin-bottom:16px">
        <div class="kbm-field">
          <label class="kbm-label">Rate From (per person) <span class="req">*</span></label>
          <input class="kbm-input" formControlName="rate" placeholder="$0.00"/>
        </div>
        <div class="kbm-field">
          <label class="kbm-label">Min Guests</label>
          <input class="kbm-input" type="number" min="1" formControlName="minGuests" placeholder="1"/>
        </div>
        <div class="kbm-field">
          <label class="kbm-label">Max Guests</label>
          <input class="kbm-input" type="number" min="1" formControlName="maxGuests" placeholder="20"/>
        </div>
        <div class="kbm-field">
          <label class="kbm-label">Duration</label>
          <input class="kbm-input" formControlName="duration" placeholder="e.g. 2 hours"/>
        </div>
        <div class="kbm-field">
          <label class="kbm-label">Meeting Location</label>
          <input class="kbm-input" formControlName="meetingLocation" placeholder="e.g. Hotel lobby"/>
        </div>
        <div class="kbm-field">
          <label class="kbm-label">Lead Time to Book</label>
          <select class="kbm-select" formControlName="leadTime">
            <option *ngFor="let l of LEAD_TIMES" [value]="l.value">{{l.name}}</option>
          </select>
        </div>
      </div>

      <!-- ── Tags & Restrictions ── -->
      <div class="kbm-section-label"><span>Tags &amp; Restrictions</span></div>
      <div class="kbm-field-grid cols-2" style="margin-bottom:16px">

        <!-- Highlights → TinyMCE editor -->
        <div class="kbm-field span-2">
          <label class="kbm-label">Highlights</label>
          <editor formControlName="highlights"
            [init]="{
              selector: 'textarea',
              plugins: 'preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons accordion',
              height: 300,
              base_url: '/tinymce',
              suffix: '.min',
              menubar: 'file edit view insert format tools table help',
              toolbar: 'undo redo | blocks fontsizeinput | bold italic | align numlist bullist | link image | table | lineheight outdent indent | strikethrough forecolor backcolor removeformat | charmap emoticons | code fullscreen preview | save print',
              autosave_ask_before_unload: true,
              autosave_interval: '30s',
              image_advtab: true,
              importcss_append: true,
              image_caption: true,
              quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
              toolbar_mode: 'sliding',
              contextmenu: 'link image table',
              content_style: 'body { font-family: Inter, Helvetica, Arial, sans-serif; font-size: 14px }'
            }">
          </editor>
        </div>

        <div class="kbm-field">
          <label class="kbm-label">Tags</label>
          <input class="kbm-input" formControlName="tags" placeholder="e.g. ocean, outdoor"/>
          <div class="kbm-hint">Comma-separated</div>
        </div>

        <div class="kbm-field">
          <label class="kbm-label">Age Restriction</label>
          <input class="kbm-input" formControlName="ageRestriction" placeholder="e.g. 6+ years"/>
        </div>

        <div class="kbm-field">
          <label class="kbm-label">Physical Requirement</label>
          <input class="kbm-input" formControlName="physicalRequirement" placeholder="e.g. Moderate fitness"/>
        </div>

        <!-- ── Included items ── -->
        <div class="kbm-field">
          <label class="kbm-label">Included</label>
          <div style="display:flex;gap:6px;margin-bottom:8px">
            <input class="kbm-input" [(ngModel)]="newIncluded" [ngModelOptions]="{standalone:true}"
              placeholder="Add item…" (keydown)="onIncludedKey($event)" style="flex:1"/>
            <button type="button" class="btn-kbm-primary btn-kbm-sm"
              style="padding:6px 10px;flex-shrink:0" (click)="addIncluded()"
              title="Add included item">+</button>
          </div>
          <div style="display:flex;flex-wrap:wrap;gap:6px;min-height:28px">
            <span *ngFor="let item of includedItems; let i = index"
              style="display:inline-flex;align-items:center;gap:4px;padding:3px 8px;background:#d1fae5;color:#065f46;border-radius:4px;font-size:12px;font-weight:500">
              {{item}}
              <button type="button" (click)="removeIncluded(i)"
                style="background:none;border:none;cursor:pointer;color:#065f46;font-size:13px;line-height:1;padding:0">×</button>
            </span>
            <span *ngIf="!includedItems.length" style="font-size:11px;color:#9ca3af">None added yet</span>
          </div>
        </div>

        <!-- ── Not Included items ── -->
        <div class="kbm-field">
          <label class="kbm-label">Not Included</label>
          <div style="display:flex;gap:6px;margin-bottom:8px">
            <input class="kbm-input" [(ngModel)]="newNotIncluded" [ngModelOptions]="{standalone:true}"
              placeholder="Add item…" (keydown)="onNotIncludedKey($event)" style="flex:1"/>
            <button type="button" class="btn-kbm-primary btn-kbm-sm"
              style="padding:6px 10px;flex-shrink:0" (click)="addNotIncluded()"
              title="Add not-included item">+</button>
          </div>
          <div style="display:flex;flex-wrap:wrap;gap:6px;min-height:28px">
            <span *ngFor="let item of notIncludedItems; let i = index"
              style="display:inline-flex;align-items:center;gap:4px;padding:3px 8px;background:#fee2e2;color:#991b1b;border-radius:4px;font-size:12px;font-weight:500">
              {{item}}
              <button type="button" (click)="removeNotIncluded(i)"
                style="background:none;border:none;cursor:pointer;color:#991b1b;font-size:13px;line-height:1;padding:0">×</button>
            </span>
            <span *ngIf="!notIncludedItems.length" style="font-size:11px;color:#9ca3af">None added yet</span>
          </div>
        </div>

        <div class="kbm-field span-2">
          <label class="kbm-label">Internal Notes</label>
          <textarea class="kbm-textarea" formControlName="internalNote" rows="2" placeholder="Staff notes…"></textarea>
        </div>
      </div>

    </ng-container>

    <!-- ══════════════════════════════════════════
         TAB: AVAILABILITY
    ══════════════════════════════════════════ -->
    <ng-container *ngIf="activeTab === 'availability'">

      <div class="kbm-section-label"><span>Days Available</span></div>
      <div class="day-selector" style="margin-bottom:20px">
        <div class="day-header">
          <span style="font-size:11px;color:#6b7280">Click to toggle</span>
          <button class="sel-all" type="button" (click)="selectAllDays()">Select all</button>
        </div>
        <div class="day-grid">
          <button *ngFor="let d of DAYS" type="button" class="day-btn"
            [class.selected]="selectedDays.includes(d)" (click)="toggleDay(d)">
            <div class="day-name">{{d}}</div>
            <div class="day-check" [class.checked]="selectedDays.includes(d)">
              {{selectedDays.includes(d) ? '✓' : ''}}
            </div>
          </button>
        </div>
      </div>

      <div class="kbm-section-label"><span>Start Times</span></div>
      <div class="time-pills" style="margin-bottom:20px">
        <button *ngFor="let t of TIME_SLOTS" type="button" class="time-pill"
          [class.selected]="selectedTimes.includes(t)" (click)="toggleTime(t)">
          {{t}}
        </button>
      </div>

      <div class="kbm-section-label"><span>Seasonal &amp; Blackout</span></div>
      <div class="kbm-field-grid cols-2">
        <div class="kbm-field">
          <label class="kbm-label">Seasonal Availability</label>
          <select class="kbm-select" formControlName="seasonal" (change)="onSeasonalChange()">
            <option *ngFor="let s of SEASONAL_OPTS" [value]="s.value">{{s.name}}</option>
          </select>
        </div>

        <!-- Custom date range (shown only when "Custom date range" selected) -->
        <div class="kbm-field" *ngIf="isCustomSeasonal">
          <label class="kbm-label">Custom Date Range</label>
          <div style="display:flex;align-items:center;gap:8px">
            <input class="kbm-input" type="date" [(ngModel)]="seasonalFrom" [ngModelOptions]="{standalone:true}"
              (change)="updateSeasonalRange()" style="flex:1"/>
            <span style="color:#9ca3af;font-size:12px;white-space:nowrap">to</span>
            <input class="kbm-input" type="date" [(ngModel)]="seasonalTo" [ngModelOptions]="{standalone:true}"
              (change)="updateSeasonalRange()" style="flex:1"/>
          </div>
          <div class="kbm-hint" *ngIf="form1.get('seasonalCustomRange')?.value">
            Saved: {{form1.get('seasonalCustomRange')?.value}}
          </div>
        </div>

        <div class="kbm-field" [class.span-2]="!isCustomSeasonal">
          <label class="kbm-label">Blackout Dates</label>
          <input class="kbm-input" formControlName="blackoutDates" placeholder="e.g. Dec 24–Jan 1"/>
          <div class="kbm-hint">Comma-separated date ranges</div>
        </div>

        <div class="kbm-field span-2">
          <label class="kbm-label">Availability Notes</label>
          <textarea class="kbm-textarea" formControlName="availabilityNote" rows="2"
            placeholder="e.g. Whale watching only available Dec–Apr…"></textarea>
        </div>
      </div>
    </ng-container>

    <!-- ══════════════════════════════════════════
         TAB: PROVIDER
    ══════════════════════════════════════════ -->
    <ng-container *ngIf="activeTab === 'provider'">

      <div class="kbm-section-label"><span>Assign Provider(s)</span></div>
      <div class="kbm-field" style="margin-bottom:16px">
        <label class="kbm-label">Activity Provider(s) <span class="req">*</span></label>
        <p-multiSelect
          [options]="providers"
          [(ngModel)]="selectedProviderIds"
          [ngModelOptions]="{standalone:true}"
          optionLabel="name"
          optionValue="activityProviderId"
          placeholder="Select one or more providers…"
          [showClear]="true"
          [filter]="true"
          filterPlaceholder="Search providers…"
          styleClass="w-100"
          [style]="{'width':'100%'}"
          appendTo="body">
        </p-multiSelect>
        <div class="kbm-hint">You can select multiple providers for this activity.</div>
      </div>

      <!-- Provider info cards for each selected provider -->
      <ng-container *ngIf="selectedProviderIds.length > 0">
        <div *ngFor="let pid of selectedProviderIds" style="margin-bottom:12px">
          <ng-container *ngFor="let p of providers">
            <div *ngIf="p.activityProviderId === pid"
              style="background:#f9fafb;border:1px solid #e5e7eb;border-radius:8px;padding:14px">
              <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:10px">
                <span style="font-weight:600;color:#1f2937;font-size:13px">{{p.name}}</span>
                <span class="badge-kbm badge-{{p.category}}">{{p.category}}</span>
              </div>
              <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:10px;font-size:12px">
                <div>
                  <div style="color:#9ca3af;font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:0.06em;margin-bottom:2px">Contact</div>
                  <div style="color:#1f2937;font-weight:500">{{p.contactName || '—'}}</div>
                </div>
                <div>
                  <div style="color:#9ca3af;font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:0.06em;margin-bottom:2px">Phone</div>
                  <div style="color:#1f2937;font-weight:500;font-family:monospace">{{p.phone || '—'}}</div>
                </div>
                <div>
                  <div style="color:#9ca3af;font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:0.06em;margin-bottom:2px">Booking</div>
                  <div style="color:#1f2937;font-weight:500">{{p.bookingMethod || '—'}}</div>
                </div>
              </div>
              <div *ngIf="p.staffNotes" style="margin-top:10px">
                <div style="font-size:10px;color:#9ca3af;font-weight:600;text-transform:uppercase;letter-spacing:0.06em;margin-bottom:3px">Staff Notes</div>
                <p style="font-size:12px;color:#374151;line-height:1.5;margin:0">{{p.staffNotes}}</p>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>

     

    </ng-container>

    <!-- ══════════════════════════════════════════
         TAB: PROPERTIES
    ══════════════════════════════════════════ -->
    <ng-container *ngIf="activeTab === 'properties'">

      <!-- Property toggles -->
      <div class="kbm-section-label" style="margin-top:20px"><span>Available At Properties</span></div>
      <div style="margin-bottom:20px">
        <div *ngIf="PROPERTIES.length === 0" style="font-size:12px;color:#9ca3af;padding:8px 0">Loading properties…</div>
        <div class="day-grid" style="grid-template-columns:repeat(auto-fill,minmax(160px,1fr))">
          <button *ngFor="let p of PROPERTIES" type="button" class="day-btn"
            [class.selected]="selectedProps.includes(p)" (click)="toggleProp(p)">
            <div class="day-name" style="font-size:11px;white-space:normal;text-align:left;line-height:1.3">{{p}}</div>
            <div class="day-check" [class.checked]="selectedProps.includes(p)">
              {{selectedProps.includes(p) ? '✓' : ''}}
            </div>
          </button>
        </div>
        <div class="kbm-hint" style="margin-top:8px">Toggle the properties where this activity is offered.</div>
      </div>

       <!-- Location dropdown -->
      <div class="kbm-section-label"><span>Activity Location</span></div>
      <div class="kbm-field-grid cols-2">
        <div class="kbm-field span-2">
          <label class="kbm-label">Location / Destination</label>
          <select class="kbm-select" formControlName="locationId">
            <option value="">Select location…</option>
            <option *ngFor="let loc of LOCATIONS" [value]="loc.locationId">
              {{loc.name}}
            </option>
          </select>
          <div class="kbm-hint">Select the geographic location where this activity takes place.</div>
        </div>
      </div>      

      <div class="kbm-section-label"><span>Display Options</span></div>
      <div class="kbm-field-grid cols-2">
        <div class="kbm-field">
          <label class="kbm-label">Sort Priority</label>
          <input class="kbm-input" type="number" min="1" formControlName="priority"/>
          <div class="kbm-hint">Lower = appears first</div>
        </div>
        <div class="kbm-field">
          <label class="kbm-label">Featured on Concierge Page</label>
          <div style="display:flex;align-items:center;gap:8px;margin-top:6px">
            <label class="kbm-toggle">
              <input type="checkbox" formControlName="featured"/>
              <span class="track"></span>
              <span class="thumb"></span>
            </label>
            <span style="font-size:13px;color:#4b5563">{{form1.get('featured')?.value ? 'Yes' : 'No'}}</span>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- ══════════════════════════════════════════
         TAB: PICTURES
    ══════════════════════════════════════════ -->
    <ng-container *ngIf="activeTab === 'pictures'">

      <!-- Save-first notice for new activities -->
      <div *ngIf="isNew"
        style="display:flex;align-items:center;gap:12px;padding:16px;background:#fffbeb;border:1px solid #fde68a;border-radius:8px;margin-bottom:20px">
        <span style="font-size:20px">💡</span>
        <div>
          <div style="font-size:13px;font-weight:600;color:#92400e">Save the activity first</div>
          <div style="font-size:12px;color:#b45309">Pictures can be uploaded after the activity has been saved at least once. Use <strong>Save Draft</strong> below.</div>
        </div>
      </div>

      <ng-container *ngIf="!isNew">

        <!-- Upload section -->
        <div class="kbm-section-label"><span>Upload Images</span></div>
        <div style="margin-bottom:24px">
          <p-fileUpload
            name="files[]"
            [customUpload]="true"
            (uploadHandler)="myUploader($event)"
            multiple="multiple"
            accept=".jpg,.jpeg,.gif,.png,.webp"
            maxFileSize="52428800"
            [disabled]="pictureLoading"
            chooseLabel="Choose Images"
            uploadLabel="Upload"
            cancelLabel="Cancel">
            <ng-template pTemplate="content">
              <ul *ngIf="uploadedFiles.length" style="margin:8px 0;padding:0 0 0 20px;font-size:13px">
                <li *ngFor="let file of uploadedFiles">{{file.name}} — {{(file.size / 1024).toFixed(0)}} KB</li>
              </ul>
            </ng-template>
          </p-fileUpload>
        </div>

        <!-- Delete checked button -->
        <div *ngIf="forDeletePictures.length > 0"
          style="display:flex;align-items:center;justify-content:space-between;margin-bottom:12px">
          <span style="font-size:13px;color:#374151">{{forDeletePictures.length}} picture(s) selected</span>
          <button type="button" class="btn-kbm-danger-outline btn-kbm-sm" (click)="deleteCheckedPictures()">
            Delete Selected
          </button>
        </div>

        <!-- Loading -->
        <div *ngIf="pictureLoading"
          style="text-align:center;padding:40px;color:#9ca3af;font-size:13px">
          <i class="pi pi-spin pi-spinner" style="font-size:20px"></i>
          <div style="margin-top:8px">Loading pictures…</div>
        </div>

        <!-- Empty state -->
        <div *ngIf="!pictureLoading && isPicture"
          style="text-align:center;padding:40px;background:#f9fafb;border:1px dashed #d1d5db;border-radius:8px;color:#9ca3af">
          <div style="font-size:32px;margin-bottom:8px">🖼️</div>
          <div style="font-size:13px;font-weight:500">No images yet</div>
          <div style="font-size:12px;margin-top:4px">Upload images above to get started.</div>
        </div>

        <!-- Picture gallery grid -->
        <div *ngIf="!pictureLoading && !isPicture"
          style="display:grid;grid-template-columns:repeat(auto-fill,minmax(160px,1fr));gap:12px">
          <div *ngFor="let pic of pictures"
            style="position:relative;border:1px solid #e5e7eb;border-radius:8px;overflow:hidden;background:#f9fafb">

            <!-- Checkbox -->
            <div style="position:absolute;top:6px;left:6px;z-index:2">
              <p-checkbox
                [binary]="true"
                [ngModel]="forDeletePictures.includes(pic.pictureId)"
                [ngModelOptions]="{standalone:true}"
                (onChange)="togglePictureCheck(pic)">
              </p-checkbox>
            </div>

            <!-- Delete button -->
            <button type="button" (click)="onDeletePicture(pic)"
              style="position:absolute;top:6px;right:6px;z-index:2;width:22px;height:22px;border-radius:50%;background:rgba(0,0,0,0.55);border:none;color:#fff;font-size:12px;cursor:pointer;display:flex;align-items:center;justify-content:center;line-height:1"
              title="Delete">✕</button>

            <!-- Image -->
            <p-image
              [src]="generateUrl(pic.url)"
              [alt]="pic.caption || 'Activity image'"
              width="100%"
              [preview]="true"
              imageStyle="width:100%;height:120px;object-fit:cover;display:block">
            </p-image>

            <!-- Caption -->
            <div style="padding:6px 8px;font-size:11px;color:#6b7280;truncate:true;overflow:hidden;white-space:nowrap;text-overflow:ellipsis">
              {{pic.caption || pic.fileName || 'Image #' + pic.pictureId}}
            </div>
          </div>
        </div>

        <div *ngIf="!pictureLoading && pictures.length > 0"
          style="margin-top:12px;font-size:11px;color:#9ca3af">
          {{pictures.length}} image(s) total
        </div>

      </ng-container><!-- /!isNew -->
    </ng-container><!-- /pictures tab -->

    <!-- ══════════════════════════════════════════
         TAB: FEES & SCHEDULES
    ══════════════════════════════════════════ -->
    <ng-container *ngIf="activeTab === 'fees'">

      <!-- Gate: activity must be saved first -->
      <div *ngIf="isNew"
        style="display:flex;align-items:center;gap:12px;padding:16px;background:#fffbeb;border:1px solid #fde68a;border-radius:8px;margin-bottom:20px">
        <i class="pi pi-info-circle" style="font-size:20px;color:#b45309"></i>
        <div>
          <div style="font-size:13px;font-weight:600;color:#92400e">Save the activity first</div>
          <div style="font-size:12px;color:#b45309">Fees and schedules can be added after the activity has been saved at least once. Use <strong>Save Draft</strong> below.</div>
        </div>
      </div>

      <ng-container *ngIf="!isNew">

        <!-- ── FEES SECTION ── -->
        <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:12px">
          <div class="kbm-section-label" style="margin-bottom:0"><span>Pricing Tiers (Fees)</span></div>
          <button type="button" class="btn-kbm-primary btn-kbm-sm" (click)="startAddFee()" [disabled]="showAddFeeRow">
            + Add Fee
          </button>
        </div>

        <!-- Loading fees -->
        <div *ngIf="feesLoading" style="text-align:center;padding:24px;color:#9ca3af;font-size:13px">
          <i class="pi pi-spin pi-spinner" style="font-size:18px"></i>
          <div style="margin-top:6px">Loading fees…</div>
        </div>

        <!-- Fees table -->
        <div *ngIf="!feesLoading" class="fs-table-wrap">
          <table class="fs-table">
            <thead>
              <tr>
                <th style="width:28px"></th>
                <th>Name</th>
                <th>Season</th>
                <th>Infant</th>
                <th>Youth</th>
                <th>Adult</th>
                <th>Senior</th>
                <th>Status</th>
                <th style="width:90px">Actions</th>
              </tr>
            </thead>
            <tbody>

              <!-- Inline Add Row -->
              <tr *ngIf="showAddFeeRow" class="fs-add-row">
                <td></td>
                <td><input class="kbm-input fs-inline-input" [(ngModel)]="newFee.name" [ngModelOptions]="{standalone:true}" placeholder="Fee name *"/></td>
                <td><input class="kbm-input fs-inline-input" [(ngModel)]="newFee.season" [ngModelOptions]="{standalone:true}" placeholder="e.g. Summer"/></td>
                <td><input class="kbm-input fs-inline-input" type="number" min="0" step="0.01" [(ngModel)]="newFee.feeInfant" [ngModelOptions]="{standalone:true}" placeholder="0.00"/></td>
                <td><input class="kbm-input fs-inline-input" type="number" min="0" step="0.01" [(ngModel)]="newFee.feeYouth" [ngModelOptions]="{standalone:true}" placeholder="0.00"/></td>
                <td><input class="kbm-input fs-inline-input" type="number" min="0" step="0.01" [(ngModel)]="newFee.feeAdults" [ngModelOptions]="{standalone:true}" placeholder="0.00"/></td>
                <td><input class="kbm-input fs-inline-input" type="number" min="0" step="0.01" [(ngModel)]="newFee.feeSeniors" [ngModelOptions]="{standalone:true}" placeholder="0.00"/></td>
                <td>
                  <select class="kbm-select fs-inline-input" [(ngModel)]="newFee.status" [ngModelOptions]="{standalone:true}">
                    <option *ngFor="let s of FEE_STATUSES" [value]="s.value">{{s.name}}</option>
                  </select>
                </td>
                <td class="fs-actions">
                  <button type="button" class="btn-kbm-primary btn-kbm-sm" (click)="saveNewFee()" [disabled]="feeAddLoading">
                    <i *ngIf="feeAddLoading" class="pi pi-spin pi-spinner"></i>
                    <span *ngIf="!feeAddLoading">Save</span>
                  </button>
                  <button type="button" class="btn-kbm-outline btn-kbm-sm" (click)="cancelAddFee()" [disabled]="feeAddLoading">Cancel</button>
                </td>
              </tr>

              <!-- Empty state -->
              <tr *ngIf="!fees.length && !showAddFeeRow">
                <td colspan="9" style="text-align:center;padding:24px;color:#9ca3af;font-size:12px">
                  No fees yet — click "Add Fee" to create the first pricing tier.
                </td>
              </tr>

              <!-- Fee rows -->
              <ng-container *ngFor="let fee of fees">

                <!-- Edit row -->
                <tr *ngIf="editingFeeId === fee.activityFeeId" class="fs-edit-row">
                  <td></td>
                  <td><input class="kbm-input fs-inline-input" [(ngModel)]="editFeeData.name" [ngModelOptions]="{standalone:true}"/></td>
                  <td><input class="kbm-input fs-inline-input" [(ngModel)]="editFeeData.season" [ngModelOptions]="{standalone:true}"/></td>
                  <td><input class="kbm-input fs-inline-input" type="number" min="0" step="0.01" [(ngModel)]="editFeeData.feeInfant" [ngModelOptions]="{standalone:true}"/></td>
                  <td><input class="kbm-input fs-inline-input" type="number" min="0" step="0.01" [(ngModel)]="editFeeData.feeYouth" [ngModelOptions]="{standalone:true}"/></td>
                  <td><input class="kbm-input fs-inline-input" type="number" min="0" step="0.01" [(ngModel)]="editFeeData.feeAdults" [ngModelOptions]="{standalone:true}"/></td>
                  <td><input class="kbm-input fs-inline-input" type="number" min="0" step="0.01" [(ngModel)]="editFeeData.feeSeniors" [ngModelOptions]="{standalone:true}"/></td>
                  <td>
                    <select class="kbm-select fs-inline-input" [(ngModel)]="editFeeData.status" [ngModelOptions]="{standalone:true}">
                      <option *ngFor="let s of FEE_STATUSES" [value]="s.value">{{s.name}}</option>
                    </select>
                  </td>
                  <td class="fs-actions">
                    <button type="button" class="btn-kbm-primary btn-kbm-sm" (click)="saveEditFee()" [disabled]="feeEditLoading">
                      <i *ngIf="feeEditLoading" class="pi pi-spin pi-spinner"></i>
                      <span *ngIf="!feeEditLoading">Save</span>
                    </button>
                    <button type="button" class="btn-kbm-outline btn-kbm-sm" (click)="cancelEditFee()" [disabled]="feeEditLoading">Cancel</button>
                  </td>
                </tr>

                <!-- Display row -->
                <tr *ngIf="editingFeeId !== fee.activityFeeId"
                  class="fs-fee-row"
                  [class.fs-expanded]="expandedFeeId === fee.activityFeeId">
                  <td>
                    <button type="button" class="fs-expand-btn"
                      (click)="toggleFeeExpand(fee)"
                      [title]="expandedFeeId === fee.activityFeeId ? 'Collapse schedules' : 'Expand schedules'">
                      <i class="pi" [class.pi-chevron-down]="expandedFeeId !== fee.activityFeeId"
                        [class.pi-chevron-up]="expandedFeeId === fee.activityFeeId"></i>
                    </button>
                  </td>
                  <td class="fs-name-cell">{{fee.name}}</td>
                  <td>{{fee.season || '—'}}</td>
                  <td class="fs-price-cell">{{fee.feeInfant != null ? ('$' + (fee.feeInfant | number:'1.2-2')) : '—'}}</td>
                  <td class="fs-price-cell">{{fee.feeYouth != null ? ('$' + (fee.feeYouth | number:'1.2-2')) : '—'}}</td>
                  <td class="fs-price-cell">{{fee.feeAdults != null ? ('$' + (fee.feeAdults | number:'1.2-2')) : '—'}}</td>
                  <td class="fs-price-cell">{{fee.feeSeniors != null ? ('$' + (fee.feeSeniors | number:'1.2-2')) : '—'}}</td>
                  <td><span class="fs-status-badge fs-status-{{fee.status}}">
                    {{fee.status === '0' ? 'Active' : fee.status === '1' ? 'Canceled' : fee.status === '2' ? 'Suspended' : fee.status}}
                  </span></td>
                  <td class="fs-actions">
                    <button type="button" class="btn-kbm-outline btn-kbm-sm" (click)="startEditFee(fee)" title="Edit fee">Edit</button>
                    <button type="button" class="btn-kbm-danger-outline btn-kbm-sm" (click)="deleteFee(fee)" title="Delete fee">Del</button>
                  </td>
                </tr>

                <!-- Schedules expanded panel -->
                <tr *ngIf="expandedFeeId === fee.activityFeeId && editingFeeId !== fee.activityFeeId" class="fs-schedule-panel-row">
                  <td colspan="9" class="fs-schedule-panel">

                    <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:10px">
                      <span style="font-size:12px;font-weight:600;color:#374151">
                        Schedules for "{{fee.name}}"
                      </span>
                      <button type="button" class="btn-kbm-primary btn-kbm-sm"
                        (click)="startAddSchedule(fee.activityFeeId)"
                        [disabled]="showAddScheduleRowByFee[fee.activityFeeId]">
                        + Add Schedule
                      </button>
                    </div>

                    <!-- Loading schedules -->
                    <div *ngIf="schedulesLoading[fee.activityFeeId]"
                      style="text-align:center;padding:16px;color:#9ca3af;font-size:12px">
                      <i class="pi pi-spin pi-spinner"></i> Loading schedules…
                    </div>

                    <div *ngIf="!schedulesLoading[fee.activityFeeId]">
                      <table class="fs-table fs-sched-table">
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Season</th>
                            <th>Start Time</th>
                            <th>End Time</th>
                            <th>Duration</th>
                            <th>Status</th>
                            <th style="width:90px">Actions</th>
                          </tr>
                        </thead>
                        <tbody>

                          <!-- Inline add schedule row -->
                          <tr *ngIf="showAddScheduleRowByFee[fee.activityFeeId]" class="fs-add-row">
                            <td><input class="kbm-input fs-inline-input" [(ngModel)]="newScheduleByFee[fee.activityFeeId].name" [ngModelOptions]="{standalone:true}" placeholder="Schedule name *"/></td>
                            <td><input class="kbm-input fs-inline-input" [(ngModel)]="newScheduleByFee[fee.activityFeeId].season" [ngModelOptions]="{standalone:true}" placeholder="e.g. Summer"/></td>
                            <td><input class="kbm-input fs-inline-input" type="time" [(ngModel)]="newScheduleByFee[fee.activityFeeId].startTime" [ngModelOptions]="{standalone:true}"/></td>
                            <td><input class="kbm-input fs-inline-input" type="time" [(ngModel)]="newScheduleByFee[fee.activityFeeId].endTime" [ngModelOptions]="{standalone:true}"/></td>
                            <td><input class="kbm-input fs-inline-input" type="number" min="0" step="0.25" [(ngModel)]="newScheduleByFee[fee.activityFeeId].duration" [ngModelOptions]="{standalone:true}" placeholder="hrs"/></td>
                            <td>
                              <select class="kbm-select fs-inline-input" [(ngModel)]="newScheduleByFee[fee.activityFeeId].status" [ngModelOptions]="{standalone:true}">
                                <option *ngFor="let s of SCHEDULE_STATUSES" [value]="s.value">{{s.name}}</option>
                              </select>
                            </td>
                            <td class="fs-actions">
                              <button type="button" class="btn-kbm-primary btn-kbm-sm" (click)="saveNewSchedule(fee.activityFeeId)" [disabled]="scheduleAddLoadingByFee[fee.activityFeeId]">
                                <i *ngIf="scheduleAddLoadingByFee[fee.activityFeeId]" class="pi pi-spin pi-spinner"></i>
                                <span *ngIf="!scheduleAddLoadingByFee[fee.activityFeeId]">Save</span>
                              </button>
                              <button type="button" class="btn-kbm-outline btn-kbm-sm" (click)="cancelAddSchedule(fee.activityFeeId)">Cancel</button>
                            </td>
                          </tr>

                          <!-- Empty state -->
                          <tr *ngIf="!(schedulesByFee[fee.activityFeeId]?.length) && !showAddScheduleRowByFee[fee.activityFeeId]">
                            <td colspan="7" style="text-align:center;padding:16px;color:#9ca3af;font-size:12px">
                              No schedules yet — click "+ Add Schedule" to create one.
                            </td>
                          </tr>

                          <!-- Schedule rows -->
                          <ng-container *ngFor="let sched of schedulesByFee[fee.activityFeeId]">

                            <!-- Edit row -->
                            <tr *ngIf="editingScheduleId === sched.activityScheduleId" class="fs-edit-row">
                              <td><input class="kbm-input fs-inline-input" [(ngModel)]="editScheduleData.name" [ngModelOptions]="{standalone:true}"/></td>
                              <td><input class="kbm-input fs-inline-input" [(ngModel)]="editScheduleData.season" [ngModelOptions]="{standalone:true}"/></td>
                              <td><input class="kbm-input fs-inline-input" type="time" [(ngModel)]="editScheduleData.startTime" [ngModelOptions]="{standalone:true}"/></td>
                              <td><input class="kbm-input fs-inline-input" type="time" [(ngModel)]="editScheduleData.endTime" [ngModelOptions]="{standalone:true}"/></td>
                              <td><input class="kbm-input fs-inline-input" type="number" min="0" step="0.25" [(ngModel)]="editScheduleData.duration" [ngModelOptions]="{standalone:true}"/></td>
                              <td>
                                <select class="kbm-select fs-inline-input" [(ngModel)]="editScheduleData.status" [ngModelOptions]="{standalone:true}">
                                  <option *ngFor="let s of SCHEDULE_STATUSES" [value]="s.value">{{s.name}}</option>
                                </select>
                              </td>
                              <td class="fs-actions">
                                <button type="button" class="btn-kbm-primary btn-kbm-sm" (click)="saveEditSchedule(fee.activityFeeId)" [disabled]="scheduleEditLoading">
                                  <i *ngIf="scheduleEditLoading" class="pi pi-spin pi-spinner"></i>
                                  <span *ngIf="!scheduleEditLoading">Save</span>
                                </button>
                                <button type="button" class="btn-kbm-outline btn-kbm-sm" (click)="cancelEditSchedule()">Cancel</button>
                              </td>
                            </tr>

                            <!-- Display row -->
                            <tr *ngIf="editingScheduleId !== sched.activityScheduleId" class="fs-sched-row">
                              <td>{{sched.name}}</td>
                              <td>{{sched.season || '—'}}</td>
                              <td>{{sched.startTimeDesc || sched.startTime || '—'}}</td>
                              <td>{{sched.endTimeDesc || sched.endTime || '—'}}</td>
                              <td>{{sched.duration != null ? (sched.duration + ' hrs') : '—'}}</td>
                              <td><span class="fs-status-badge fs-status-{{sched.status}}">
                                {{sched.status === '0' ? 'Active' : sched.status === '1' ? 'Canceled' : sched.status === '2' ? 'Suspended' : sched.status}}
                              </span></td>
                              <td class="fs-actions">
                                <button type="button" class="btn-kbm-outline btn-kbm-sm" (click)="startEditSchedule(sched)">Edit</button>
                                <button type="button" class="btn-kbm-danger-outline btn-kbm-sm" (click)="deleteSchedule(fee.activityFeeId, sched)">Del</button>
                              </td>
                            </tr>

                          </ng-container>

                        </tbody>
                      </table>
                    </div><!-- /!schedulesLoading -->

                  </td>
                </tr><!-- /schedule panel row -->

              </ng-container><!-- /fee rows -->

            </tbody>
          </table>
        </div><!-- /fs-table-wrap -->

      </ng-container><!-- /!isNew -->
    </ng-container><!-- /fees tab -->

  </div><!-- /kbm-modal-body -->

  <!-- ── FOOTER ── -->
  <div class="kbm-modal-footer">
    <div>
      <button *ngIf="!isNew" type="button" class="btn-kbm-danger-outline btn-kbm-sm" (click)="onArchive()">Archive</button>
    </div>
    <div style="display:flex;gap:8px;margin-left:auto">
      <button type="button" class="btn-kbm-outline" mat-dialog-close [disabled]="formLoading">Discard</button>
      <button type="button" class="btn-kbm-outline" (click)="saveDraft()" [disabled]="formLoading">Save Draft</button>
      <button type="button" class="btn-kbm-primary" (click)="savePublish()" [disabled]="formLoading">
        {{formLoading ? 'Saving…' : 'Publish Activity'}}
      </button>
    </div>
  </div>

</div>
